import { type Group } from 'three'
import BaseFileLoader from './base-file-loader'
import { ThreeItemKeys, ThreeOriginalFileTypes } from '../../../constants/three'
import { GCodeLoader } from './three-loaders'
import { setFileLoadingStatus } from '../../../stores/file-loading'

class GCodeFileLoader extends BaseFileLoader {
  // GCode loader has custom implementation that can't run in a Worker
  protected shouldUseWorker(): boolean {
    return false
  }

  async load(): Promise<Group> {
    return this.loadWithProgress(async () => {
      if (!this.base64File) {
        await this.loadBase64()
      }

      setFileLoadingStatus('parsing', this.file.name, 30)

      const loader = new GCodeLoader()
      return new Promise((resolve, reject) => {
        loader.load(this.base64File!, (bufferGeometry: Group) => {
          try {
            setFileLoadingStatus('processing', this.file.name, 60)

            bufferGeometry.traverse((child) => {
              if ('material' in child) {
                child.material = this.getLineMaterial()
              }
            })
            bufferGeometry.position.set(0, 0, 0)

            setFileLoadingStatus('finalizing', this.file.name, 80)

            const result = this.addMeshesToScene([this.scaleDownObject(bufferGeometry)], this.file, () => ({
              [ThreeItemKeys.ORIGINAL_FILE_TYPE]: this.getFileExtension() === 'mxp'
                ? ThreeOriginalFileTypes.MXP
                : ThreeOriginalFileTypes.MPP,
            }))

            resolve(result)
          }
          catch (error) {
            reject(error)
          }
        })
      })
    })
  }
}

export default GCodeFileLoader
